import { collection, addDoc, getDocs, doc, updateDoc, query, orderBy, Timestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../firebase';
import { SharedImage, ImageUploadData } from '../types/image';

const IMAGES_COLLECTION = 'shared_images';

export const uploadImage = async (data: ImageUploadData): Promise<string> => {
  const docRef = await addDoc(collection(db, IMAGES_COLLECTION), {
    ...data,
    createdAt: Timestamp.now(),
    likes: 0,
    likedBy: []
  });
  return docRef.id;
};

export const getImages = async (): Promise<SharedImage[]> => {
  const q = query(collection(db, IMAGES_COLLECTION), orderBy('createdAt', 'desc'));
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    createdAt: doc.data().createdAt.toDate()
  })) as SharedImage[];
};

export const toggleLike = async (imageId: string, userId: string, currentLikes: number, likedBy: string[]): Promise<void> => {
  const imageRef = doc(db, IMAGES_COLLECTION, imageId);
  const isLiked = likedBy.includes(userId);
  
  const newLikedBy = isLiked 
    ? likedBy.filter(id => id !== userId)
    : [...likedBy, userId];
    
  await updateDoc(imageRef, {
    likes: isLiked ? currentLikes - 1 : currentLikes + 1,
    likedBy: newLikedBy
  });
}; 